import React from "react";

// Generated Scottys Land Specialist logo
export const SCOTTY_LOGO_URL =
  "https://vibe.filesafe.space/1792678768838541728/attachments/4807b41e-2583-45bd-b584-b9a7c8c48a20.jpg";

interface ScottyLogoProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl" | "2xl";
}

export const ScottyLogo: React.FC<ScottyLogoProps> = ({
  className = "",
  size = "lg",
}) => {
  const sizeClasses: Record<string, string> = {
    sm: "h-11 sm:h-12 lg:h-14",
    md: "h-20 sm:h-24 md:h-28",
    lg: "h-24 sm:h-28 lg:h-32",
    xl: "h-28 sm:h-32 lg:h-36",
    "2xl": "h-32 sm:h-40 lg:h-44",
  };

  return (
    <div className={`inline-flex items-center ${className}`}>
      <img
        src={SCOTTY_LOGO_URL}
        alt="Scottys Land Specialist Logo"
        width={1464}
        height={941}
        className={`${sizeClasses[size]} w-auto max-h-full object-contain object-center`}
      />
    </div>
  );
};
